import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";

const TributeModal = ({ show, onHide, onSubmit }) => {
  const validationSchema = Yup.object({
    message: Yup.string().required("Tribute message is required"),
    author: Yup.string().required("Author name is required"),
  });

  return (
    <Modal className="commn-modal-css" show={show} onHide={onHide} centered>
      <Modal.Header className="border-0" closeButton></Modal.Header>
      <Formik
        initialValues={{ message: "", author: "" }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <Form onSubmit={handleSubmit} className="commn-form-set-profile">
            <Modal.Body className="pt-0">
              <h2>Submit a Tribute</h2>
              <Form.Group className="mb-3">
                <Form.Label>Your Name</Form.Label>
                <Form.Control
                  type="text"
                  name="author"
                  value={values.author}
                  onChange={handleChange}
                  isInvalid={touched.author && errors.author}
                  placeholder="Enter your name"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.author}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Tribute Message</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  name="message"
                  value={values.message}
                  onChange={handleChange}
                  isInvalid={touched.message && errors.message}
                  placeholder="Share your memories and thoughts..."
                />
                <Form.Control.Feedback type="invalid">
                  {errors.message}
                </Form.Control.Feedback>
              </Form.Group>
              <div className="d-flex justify-content-end gap-2 comnn-modal-action">
                <button className="outline" onClick={onHide}>
                  Cancel
                </button>
                <button type="submit" className="fill" disabled={isSubmitting}>
                  {isSubmitting ? "Submitting..." : "Submit Tribute"}
                </button>
              </div>
            </Modal.Body>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default TributeModal;
